// src/components/common/QRPlaceholder.js
// Filepath: // src/components/common/QRPlaceholder.js
import React from "react";
import { Card, CardContent, Box, Typography } from "@mui/material";

export default function QRPlaceholder({ text = "Scan to sign in" }) {
  return (
    <Card sx={{ width: 280, borderRadius: "10px" }}>
      <CardContent sx={{ display: "grid", placeItems: "center" }}>
        <Box sx={{
          width: 200, height: 200, borderRadius: "10px",
          background: "repeating-linear-gradient(45deg,#222 0 8px,#333 8px 16px)"
        }} />
        <Typography sx={{ mt: 1, color: "text.secondary" }}>{text}</Typography>
      </CardContent>
    </Card>
  );
}
